import { createSelector } from '@reduxjs/toolkit';
import { EFacilityType } from '../../../../packages/JsonQuery';
import { selectHasBath, selectHasShower } from 'shared/selectors/jsonQuery';

export const selectBathTypeValue = createSelector([selectHasBath, selectHasShower], (hasBath, hasShower) => {
  const bathTypes: EFacilityType[] = [];

  if (hasBath) {
    bathTypes.push(EFacilityType.Bath);
  }

  if (hasShower) {
    bathTypes.push(EFacilityType.Shower);
  }

  return bathTypes.length > 0 ? bathTypes : [null];
});
